import React, { useState } from "react";
import {
  Form,
  FormControl,
  Button,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { MdNoteAdd } from "react-icons/md";
import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";
import { showNotification } from "services/NotificationService";

const Noter = ({ entityId, onNewNote, entitySaveUrl }) => {
  const [enabled, setEnabled] = useState(false);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  const save = () => {
    if (!note.trim()) {
      showNotification({
        title: "Unable to save note!",
        message: "Cannot save empty note.",
        position: "tr",
        type: "info",
      });
      return;
    }

    setSaving(true);
    sendAuthenticatedAsyncRequest(
      `${entitySaveUrl}/${entityId}`,
      "POST",
      { note: note },
      (r) => {
        onNewNote(r.data);
        setNote("");
        setEnabled(false);
        setSaving(false);
      },
      (r) => {
        setSaving(false);
        showNotification({
          title: "Unable to save note",
          message: "An error occurred while saving the note.",
          position: "tr",
          type: "error",
        });
      }
    );
  };

  if (!enabled) {
    return (
      <OverlayTrigger overlay={<Tooltip>Add New Note</Tooltip>} placement="top">
        <Button size="sm" variant="secondary" className="pull-right btn-text-white" onClick={() => setEnabled(true)}>
          <MdNoteAdd />
        </Button>
      </OverlayTrigger>
    );
  }

  return (
    <div className="mt-2">
      <Form.Group>
        <FormControl as="textarea" rows={2} placeholder="Add a new note..." onChange={(e) => setNote(e.target.value)} value={note} />
        <div style={{ paddingTop: 5, textAlign: "right" }}>
          <Button size="sm" variant="warning" onClick={() => setEnabled(false)} disabled={saving}>
            Cancel
          </Button>{" "}
          &nbsp;
          <Button size="sm" variant="success" onClick={save} disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </Button>
        </div>
      </Form.Group>
    </div>
  );
};

export default Noter;
